import autosize from 'autosize';

Vue.directive('autosize', {
    inserted(el) {
        autosize(el);
    },
    update(el) {
        if (el.offsetParent === null) {
            return autosize.destroy(el);
        }

        autosize(el);
    },
});



